// src/pages/ActivityDetail.jsx

import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { supabase } from "../lib/supabaseClient";

import "./ActivityDetail.css";

const ActivityDetail = () => {
    const { slug } = useParams();

    const [activity, setActivity] = useState(null);
    const [images, setImages] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const loadActivity = async () => {
            setLoading(true);
            setError("");

            try {
                /* ------------------------------------------
                   FETCH ACTIVITY
                   ------------------------------------------ */

                const { data: activityData, error: activityError } =
                    await supabase
                        .from("activities")
                        .select(`
              id,
              title,
              slug,
              category,
              activity_date,
              location,
              description,
              cover_image,
              gallery_images,
              published
            `)
                        .eq("slug", slug)
                        .eq("published", true)
                        .single();

                if (activityError) {
                    console.error(
                        "Error loading activity:",
                        activityError
                    );

                    setError("Activity not found.");
                    return;
                }

                setActivity(activityData);
                setImages(activityData.gallery_images || []);


                /* ------------------------------------------
                   FETCH ACTIVITY GALLERY
                   ------------------------------------------ */

                // const { data: imageData, error: imageError } =
                //   await supabase
                //     .from("activity_images")
                //     .select(`
                //       id,
                //       image_url,
                //       display_order
                //     `)
                //     .eq("activity_id", activityData.id)
                //     .order("display_order", {
                //       ascending: true,
                //     });


                // if (imageError) {
                //   console.error(
                //     "Error loading activity images:",
                //     imageError
                //   );

                //   setImages([]);
                // } else {
                //   setImages(imageData || []);
                // }

            } catch (err) {
                console.error(
                    "Unexpected error loading activity:",
                    err
                );

                setError(
                    "Something went wrong while loading this activity."
                );
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            loadActivity();
        }
    }, [slug]);


    /* ------------------------------------------
       LOADING
       ------------------------------------------ */

    if (loading) {
        return (
            <main className="activity-detail-page">
                <div className="activity-detail-status">
                    Loading activity...
                </div>
            </main>
        );
    }


    /* ------------------------------------------
       ERROR / NOT FOUND
       ------------------------------------------ */

    if (error || !activity) {
        return (
            <main className="activity-detail-page">
                <div className="activity-detail-status">
                    <h1>Activity Not Found</h1>

                    <p>
                        The activity you are looking for could not
                        be found.
                    </p>

                    <Link
                        to="/"
                        className="activity-detail-back"
                    >
                        ← Back to Home
                    </Link>
                </div>
            </main>
        );
    }


    /* ------------------------------------------
       DATE FORMATTER
       ------------------------------------------ */

    const formattedDate = activity.activity_date
        ? new Date(
            `${activity.activity_date}T00:00:00`
        ).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
        })
        : null;


    return (
        <main className="activity-detail-page">

            {/* ==========================================
          HERO
          ========================================== */}

            <section className="activity-detail-hero">

                <div className="activity-detail-container">

                    <div className="activity-detail-meta">

                        {activity.category && (
                            <span>
                                {activity.category}
                            </span>
                        )}

                        {formattedDate && (
                            <span>
                                {formattedDate}
                            </span>
                        )}

                        {activity.location && (
                            <span>
                                {activity.location}
                            </span>
                        )}

                    </div>


                    <h1>
                        {activity.title}
                    </h1>

                </div>

            </section>


            {/* ==========================================
          COVER IMAGE
          ========================================== */}

            {activity.cover_image && (
                <section className="activity-detail-cover">

                    <div className="activity-detail-container">

                        <img
                            src={activity.cover_image}
                            alt={activity.title}
                        />

                    </div>

                </section>
            )}


            {/* ==========================================
          DESCRIPTION
          ========================================== */}

            {activity.description && (
                <section className="activity-detail-description">

                    <div className="activity-detail-container">

                        <div className="activity-detail-content">

                            <span className="activity-detail-eyebrow">
                                ABOUT THE ACTIVITY
                            </span>

                            <h2>
                                {activity.title}
                            </h2>

                            <div className="activity-detail-text">
                                {activity.description}
                            </div>

                        </div>

                    </div>

                </section>
            )}


            {/* ==========================================
          GALLERY
          ========================================== */}

            {images.length > 0 && (
                <section className="activity-detail-gallery">

                    <div className="activity-detail-container">

                        <div className="activity-gallery-heading">

                            <span className="activity-detail-eyebrow">
                                ACTIVITY GALLERY
                            </span>

                            <h2>
                                Moments from the activity
                            </h2>

                        </div>


                        <div className="activity-gallery-grid">

                            {images.map((image, index) => (
                                <div key={`${image}-${index}`} className="activity-gallery-item">
                                    <img
                                        src={image}
                                        alt={`${activity.title} activity ${index + 1}`}
                                        loading="lazy"
                                    />
                                </div>
                            ))}

                        </div>

                    </div>

                </section>
            )}


            {/* ==========================================
          BACK
          ========================================== */}

            <section className="activity-detail-footer">

                <div className="activity-detail-container">

                    <Link
                        to="/"
                        className="activity-detail-back"
                    >
                        ← Back to Home
                    </Link>

                </div>

            </section>

        </main>
    );
};

export default ActivityDetail;